module.exports = __webpack_public_path__ + "72ecc3957f4108c3188b7d4b7cad28a5.pdf";